import { ConsentType } from '@imprivata-cloud/authn';
import {
  CheckDpaConsentResponseActionType as CheckConsentActionType,
  type SelfServiceLandingPageDataResponse,
  type ConsentInfo,
} from '../../api/types';
import { ConsentGrantType } from '../../api/constants';

export const consentNeeded = (consentInfo: Pick<ConsentInfo, 'grantType' | 'actionType'>) => {
  return (
    consentInfo.grantType === ConsentGrantType.NOT_GRANTED ||
    consentInfo.actionType === CheckConsentActionType.CHECK_NEEDED ||
    consentInfo.actionType === CheckConsentActionType.UPDATE_NEEDED
  );
};

export const getBiometricsConsentInfo = (data?: SelfServiceLandingPageDataResponse) => {
  return data?.consentInfos?.find((info) => info.consentType === ConsentType.BIOMETRICS);
};

export const hasCamera = async () => {
  if (!navigator.mediaDevices || !('enumerateDevices' in navigator.mediaDevices)) {
    console.log('enumerateDevices() not supported.');
    return false;
  }

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const hasCamera = devices.some((device) => device.kind === 'videoinput');
    return hasCamera;
  } catch (err) {
    console.error('Error checking camera:', err);
    return false;
  }
};
